import 'core-js/stable';
import 'regenerator-runtime/runtime';
import 'intersection-observer';
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import { BootstrapVue } from 'bootstrap-vue';
import VueAnalytics from 'vue-analytics';
import Notifications from 'vue-notification';
import './polyfills/matches';

import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/pro-solid-svg-icons';
import { fal } from '@fortawesome/pro-light-svg-icons';
import { fad } from '@fortawesome/pro-duotone-svg-icons';

import { AxiosService } from './services';

library.add(fas);
library.add(fal);
library.add(fad);

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
Vue.component('font-awesome-icon', FontAwesomeIcon);

//Vue Carousel
import VueAwesomeSwiper from 'vue-awesome-swiper';
import './styles/swiper.scss'; // work around for environment bug (last version for vue2)
import './styles/swiper-min.css'; // work around for environment bug (last version for vue2)
import './styles/swiper-pagination.scss'; // work around for environment bug (last version for vue2)
import './styles/main.scss';

Vue.use(VueAwesomeSwiper);

Vue.config.productionTip = false;
Vue.use(BootstrapVue);
Vue.use(Notifications);

// Google analytics, and don't ask why I didn't set it up this way the first time
Vue.use(VueAnalytics, {
  id: process.env.VUE_APP_GOOGLE_ANALYTICS_ID,
  router,
  debug: {
    enabled: false,
    trace: true,
  },
});

const vueApp = new Vue({
  router,
  render: h => h(App),
}).$mount('#app');

// Axios Service Handler
AxiosService.init(vueApp);
